import { sortBy } from 'lodash-es';

import { hasValue } from '.';
import { RecordType } from '../..';
import { RecordPropertyForDisplay } from './RecordProperty';

export const useExtractedFields = (
  parsedFields: RecordType,
  showEmpty: boolean
) => {
  const fields: RecordPropertyForDisplay[] = sortBy(
    Object.entries(parsedFields),
    ([name]) => name
  ).map(([name, value]) => ({
    label: name,
    name: `fields.${name}`,
    value,
  }));

  if (showEmpty) {
    return fields;
  }

  return fields.filter(({ value }) => hasValue(value));
};
